import { useMemo } from "react";

import { useAuthentication } from "@app/store/useAuthtentication";
import {
  can,
  buildMapFromCategories,
  normalizePermissions,
  type PermissionsMap
} from "@app/common/utils/permissions";

export const usePermissions = () => {
  const { idProfile, idAccount, accounts } = useAuthentication((state) => state.auth.dataBiowel);
  const allCategories = useAuthentication((state) => state.auth.allCategory.all_Categories);

  const permissionsMap = useMemo<PermissionsMap>(() => {
    const currentAccount = (accounts ?? []).find((acc) => acc.id === +idAccount);
    const permissionList = currentAccount?.profile?.[0]?.permission ?? [];

    if (permissionList.length > 0) {
      return normalizePermissions(permissionList);
    }

    return buildMapFromCategories(allCategories ?? [], idProfile);
  }, [accounts, idAccount, allCategories, idProfile]);

  const hasPermission = (action: string, prefix: string): boolean =>
    can({ map: permissionsMap, action, prefix });

  return {
    can: hasPermission,
    permissionsMap
  };
};
